import { EProductType } from '../../../../types/redux/checkout';

const PRODUCT_TYPE_MAP = {
  [EProductType.Package]: 'пакета',
  [EProductType.Subscription]: 'подписки',
};

export const getPriceTitle = (productType: EProductType): string => {
  return `Стоимость ${PRODUCT_TYPE_MAP[productType] || ''}`;
};
